import { enableProdMode, importProvidersFrom } from '@angular/core';


import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthErrorInterceptorService } from '@shared/services/auth/auth-error-interceptor.service';
import { ResponseWithSuccessInterceptor } from './app/modules/login/register/response-with-success.interceptor';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { AngularSplitModule } from 'angular-split';
import { DragulaModule } from 'ng2-dragula';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { provideRouter } from "@angular/router";

if ( environment.production ) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideRouter(routes),
        importProvidersFrom(BrowserModule, AngularSplitModule, DragulaModule.forRoot()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthErrorInterceptorService,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ResponseWithSuccessInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
    .catch( err => console.error( err ) );
